/*
 * @Author: bill
 * @Date: 2023-03-13 10:05:28
 * @LastEditors: wangzijun@bzstech.com wangzijun@bzstech.com
 * @LastEditTime: 2024-06-11 15:51:49
 * @FilePath: /study/src/App.tsx
 * @Description:
 */
import React from "react";
import styles from "./App.module.css";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import { Spin, ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import "dayjs/locale/zh-cn";
import dayjs from "dayjs";
import Layout from "./layout";

declare const window: any;

dayjs.locale("zh-cn");

function App() {
  return (
    <div className={styles.App}>
      <ConfigProvider prefixCls="loveu" locale={zhCN}>
        <Provider store={store}>
          <BrowserRouter
            basename={window.__POWERED_BY_QIANKUN__ ? "/study" : "/"}
          >
            <React.Suspense fallback={<Spin />}>
              <Layout />
            </React.Suspense>
          </BrowserRouter>
        </Provider>
      </ConfigProvider>
    </div>
  );
}

export default App;
